export const NOTIFICATION_TYPES = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARNING_ERROR: 'WARNING_ERROR'
}

export const SELECT_TYPES = {
  DEFAULT: 'default',
  INLINE: 'inline',
  UNDERLINE: 'underline',
  'TWO_LINES': 'two-lines'
}
